module.exports = __webpack_public_path__ + "static/img/icon3.1a2ac5f4.png";